import i18n from '@/plugins/i18n';

const ingressCharts = () => ({
  lineChartsOverviewPage: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.healthyHostCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_elb_healthy_host_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {},
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.unhealthyHostCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_elb_unhealthy_host_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {},
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.avgRequests'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_elb_average_request_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {},
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.avgResponseTime'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_elb_average_response_time',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {},
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('aws.totalInstance'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#CF4F4F', '#2F91EC', '#F59600', '#85CF6B', '#9E46F6'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: 'service_elb_instance_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {},
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1',
      aggregationType: 'sum',
    },
  ],
  lineChartsALB: [
    {
      metricName: 'elb_alb_total_request_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalRequestCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_target_response_time',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.targetResponseTime'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.timeInMicroSecond'),
      },
    },
    {
      metricName: 'elb_alb_total_request_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.callsPerMinute'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.countPerMin'),
      },
    },
    {
      metricName: 'elb_alb_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.errorsPerMinute'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.countPerMin'),
      },
    },
    {
      metricName: 'elb_alb_rejected_request_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.rejectedRequests'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_http_fixed_response_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.httpFixedResponseCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_4xx_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http4xxErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_5xx_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http5xxErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_active_connection_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalActiveConnections'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_processed_bytes',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalProcessedBytesCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_2xx_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http2xxCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_alb_3xx_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http3xxCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
  ],
  lineChartsNLB: [
    {
      metricName: 'elb_nlb_rejected_request_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.rejectedRequests'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_nlb_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.errorsPerMinute'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.countPerMin'),
      },
    },
    {
      metricName: 'elb_nlb_port_allocation_error',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.portAllocationErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_nlb_client_tls_negotiation_error_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.clientTlsNegotiationErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_nlb_active_flow_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalActiveConnections'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_nlb_processed_bytes',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalProcessedBytesCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_nlb_target_tls_negotiation_error_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.targetNegotiationErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
  ],
  lineChartsCLB: [
    {
      metricName: 'elb_clb_total_request_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalRequestCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_clb_latency',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.latency'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.timeInMicroSecond'),
      },
    },
    {
      metricName: 'elb_clb_total_request_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.callsPerMinute'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.countPerMin'),
      },
    },
    {
      metricName: 'elb_clb_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.errorsPerMinute'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.countPerMin'),
      },
    },
    {
      metricName: 'elb_clb_4xx_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http4xxErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_clb_5xx_errors',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http5xxErrors'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_clb_active_connection_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalActiveConnections'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_clb_estimated_processed_bytes',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.totalProcessedBytesCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_clb_2xx_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http2xxCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
    {
      metricName: 'elb_clb_3xx_count',
      queryMetricType: 'readMetricsValues',
      valueColumn: 'value',
      width: '49%',
      headers: [
        {
          label: i18n.global.t('alert.instances'),
          width: '60%',
          key: 'label',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.avg'),
          width: '20%',
          key: 'avg',
          sortable: false,
        },
        {
          label: i18n.global.t('aws.max'),
          width: '20%',
          key: 'max',
          sortable: false,
        },
      ],
      isMultiMetric: true,
      entityType: 'ServiceInstance',
      formula: (value) => parseFloat(value).toFixed(3),
      title: i18n.global.t('aws.http3xxCount'),
      graphTitles: {
        x: i18n.global.t('aws.time'),
        y: i18n.global.t('aws.count'),
      },
    },
  ],
});

export default ingressCharts;
